import { directAxiosInstance } from "./api"
import { safeLogger } from "@commonUtils"

export const apiResponseLogger = (response) => {
    try {
        safeLogger.debug({
            message: `${JSON.stringify(response.data)}`,
            uri: response.request.path,
        })
    } catch (error) {
        safeLogger.error({
            message: "Error while logging API responses",
            traceback: error && error.message,
        })
    }
}

export const isAdmin = (userRoles) => {
    // I think "ROLE_CCARE" should be "ROLE_CARE", but keeping it the same as this is what we have in HKP
    if (userRoles?.includes("ROLE_ADMIN") || userRoles?.includes("ROLE_CCARE")) {
        return true
    }
    return false
}

export const isTelesales = (userRoles) => {
    if (
        userRoles?.includes("ROLE_TELESALES") ||
        userRoles?.includes("ROLE_OFFLINE_INBOUND_TELESALES") ||
        userRoles?.includes("ROLE_OFFLINE_OUTBOUND_TELESALES")
    ) {
        return true
    }
    return false
}
export const autoLogin = (data) => {
    const options = {
        url: "auth/auto_login",
        method: "POST",
        data,
    }
    return directAxiosInstance()(options)
        .then((data) => {
            return Promise.resolve(data)
        })
        .catch((err) => {
            return Promise.reject(err)
        })
}
